import { getRequestPAdmin } from "common/HttpClient/http-utility";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";

export const HomeServices = () => {
  const apiPaths = INFRAMARK_CONSTANTS.groups.services;

  const services = {
    getAllCustomers: async () => {
      const response = await getRequestPAdmin(`${apiPaths.activeGroups}`);
      return response;
    },
  };
  return services;
};
